import { render, staticRenderFns } from "./modelDetail.vue?vue&type=template&id=32541f6a"
import script from "./modelDetail.vue?vue&type=script&lang=js"
export * from "./modelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports